import { create } from '@thoughtspot/logger';
import { sendMessage as sendToEl } from 'promise-postmessage';
import { ErrorTypes } from '../components/chart-error/chart-error.helper';
import { pTimeout } from '../utils/common-util';
const logger = create('PostMessageEventDispatcher');
const PROMISE_TIMEOUT = 30 * 1000;
export const sendMessage = async (iframeRef, msgObject, appUrl) => {
    const resp = await pTimeout(sendToEl(iframeRef.current, msgObject, {
        origin: appUrl,
        endpoint: 'parent',
    }), PROMISE_TIMEOUT, ErrorTypes.MESSAGE_TIMEOUT_ERROR);
    if (resp?.hasError) {
        throw resp.error;
    }
    return {
        data: resp,
    };
};
//# sourceMappingURL=post-message-event-dispatcher.js.map